export const environment = {
  production: true,
  buildId: '2572635366117741',
  configFile: 'config.json',
};
